var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.635 24.9177L21.6717 17.7447C21.1723 17.2301 20.5483 17.0241 20.2779 17.2872C20.0066 17.5484 19.3821 17.3429 18.8827 16.8283L18.7832 16.7253C21.8997 12.6382 21.5972 6.78632 17.8547 3.0546C13.7702 -1.0182 7.1475 -1.0182 3.06343 3.0546C-1.02114 7.1274 -1.02114 13.73 3.06343 17.8028C6.86969 21.5986 12.8772 21.8528 16.9845 18.5745L17.0282 18.62C17.5266 19.1346 17.7123 19.7633 17.4401 20.025C17.1692 20.2867 17.3535 20.9159 17.8534 21.4296L24.813 28.6054C25.3123 29.1186 26.135 29.1339 26.6517 28.6356L28.6048 26.7511C29.1195 26.254 29.1334 25.4342 28.635 24.9177ZM15.5563 15.5109C12.7455 18.314 8.17141 18.314 5.36099 15.5118C2.55016 12.7091 2.55058 8.14767 5.36099 5.34545C8.17141 2.54272 12.7455 2.54314 15.5554 5.34588C18.3666 8.14819 18.3666 12.7086 15.5563 15.5109Z",
    fill: "#457E9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectImg2);
export default __webpack_public_path__ + "static/media/rect-img-2.b7a5f926f4e1d2ce5a1fab16e33832c1.svg";
export { ForwardRef as ReactComponent };